import React from 'react';
import Logo from '../../images/logo.png';

import type { SingleCardProps } from '../../types';

import './CardAuth.scss';

export const CardAuth = ({ title, description, children }: React.PropsWithChildren<SingleCardProps>) => {
  return (
    <div className='auth-card'>

      <div className='dx-card content'>
        <div className='logoPpal'>
          <img src={Logo} alt='Imagen corporativa' width={200} />
        </div>
        <div className='header'>
          <div className='title'>{ title }</div>
          <div className='description'>{ description }</div>
        </div>
        {children}
      </div>
    </div>
  );
};
